import api from '@/api'
import siteConfig from '@/assets/siteConfig'

export default {
  state: {
    config: siteConfig.getConfig()
  },

  mutations: {
    setThemeConfig (state, { config }) {
      state.config = siteConfig.mergeConfig(state.config, config)
      // console.log('state.config', state.config)
    }
  },

  actions: {
    setSiteThemeConfig ({ commit }, data) {
      const config = siteConfig.getData(data.body.config)
      return api.config.setSiteThemeConfig({
        params: data.params,
        body: { config: JSON.stringify(config) }
      })
    },

    getSiteThemeConfig ({ commit }, data) {
      return api.config.getSiteThemeConfig(data).then(response => {
        const config = response.data.config || '{}'
        commit('setThemeConfig', { config: JSON.parse(config) })
        return response
      })
    }
  }
}
